import { Component, Input, OnInit } from '@angular/core';
import { AssignedZoneDTO } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-tariff-details-zones',
    templateUrl: './tariff-details-zones.component.html',
    styleUrls: ['./tariff-details-zones.component.scss'],
    standalone: true,
    imports: [NgFor, TranslateModule]
})
export class TariffDetailsZonesComponent implements OnInit {
  @Input() assignedZones: AssignedZoneDTO[];

  constructor() { }

  ngOnInit() {
  }

}
